import { useCallback } from 'react';
import type { CoverPictureSource } from 'fym-shared/src/music24/coverDoc';
import { useCoverEditor } from '../../CoverEditorContext';

/**
 * Makes a picture the background of the cover (an AI picture, a bank picture or an upload), in the
 * middle with no zoom. With a palette, the colour swatches of the editor become the colours of
 * the picture. The text boxes keep their colours.
 */
export function usePickPicture() {
  const { dispatch } = useCoverEditor();
  return useCallback(
    (source: CoverPictureSource, url: string, palette?: readonly string[]) => {
      dispatch({
        type: 'setBackground',
        background: { kind: 'picture', source, url, focusX: 0.5, focusY: 0.5, zoom: 1 },
        palette: palette !== undefined && palette.length > 0 ? [...palette] : undefined,
      });
    },
    [dispatch]
  );
}
